import { Card, CardBody, Col } from "reactstrap";
import CommonCardHeader from "../../../../Common/CommonCardHeader";
import { WithoutShadowCards } from "../../../../Constant";
import { WITHOUT_SHADOW_CARD } from "../../../../Data/Bonus Ui/BasicCard";
import { Image, P } from "../../../../AbstractElements";
import { dynamicImage } from "../../../../Service/DynamicImage";

const WithoutshadowCard = () => {
  return (
    <Col sm="12" xl="6">
      <Card className="shadow-none border">
        <CommonCardHeader title={WithoutShadowCards} span={WITHOUT_SHADOW_CARD} headerClass={true} />
        <CardBody>
          <div className="flex-space flex-wrap align-items-center">
            <Image className="tab-img" src={dynamicImage("avtar/3.jpg")} alt="profile" />
            <P><strong>Visit Us: </strong> 2600 Hollywood Blvd,Florida, United States- 33020<br /><strong>Mail Us:</strong>contact@us@gmail.com<br /><strong>Contact Number: </strong>(954) 357-7760</P>
          </div>
        </CardBody>
      </Card>
    </Col>
  );
};

export default WithoutshadowCard;
